var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfileBlob = function SvgProfileBlob(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 49"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BF9BB9",
    d: "M38.922.501C36.458.15 35.4 1.792 31.176 5.313 29.58 6.676 13.808 16.696 10.287 18.222c-3.52 1.525-6.572 2.816-8.92 5.163s-1.408 8.332.822 11.266S8.884 45.354 23.43 48.5c13.026 2.817 24.174-16.077 25.113-22.767s-2.23-15.138-3.403-17.955S41.385.854 38.92.502Z"
  })));
};
export default SvgProfileBlob;